import { memo, useState } from "react";
import clsx from "clsx";

import { Typography } from "../typography";

import type { IChipProps } from "./types";
import styles from "./styles.module.scss";
import { getColor } from "./getColor";

export const Chip = memo(function Chip(props: IChipProps) {
  const { value, name, children, className, chipClassName } = props;

  const [hidden, setHidden] = useState(true);

  return (
    <div className={clsx([styles.wrapper, className])}>
      <div className={styles.chipContainer}>
        {Array.isArray(name) ? (
          name.map((chipValue, index) => {
            return (
              <div
                key={chipValue}
                className={`${styles.chip} ${chipClassName || ""} ${index > 0 && hidden && styles.hidden}`}
                style={{
                  color: getColor(chipValue),
                  background: `${getColor(chipValue)}1A`,
                }}
              >
                {value[index]}
              </div>
            );
          })
        ) : (
          <div
            className={clsx([styles.chip, chipClassName])}
            style={{
              color: getColor(name),
              background: `${getColor(name)}1A`,
            }}
          >
            <Typography
              fontFamily={"inherit"}
              fontSize={"inherit"}
              fontWeight={"inherit"}
            >
              {value}
            </Typography>{" "}
            {children}
          </div>
        )}
      </div>
      {Array.isArray(name) &&
        name.length > 1 &&
        (hidden ? (
          <div
            className={styles.secondaryChip}
            onClick={() => {
              setHidden(false);
            }}
          >
            {name.length - 1}
            {"+\r"}
          </div>
        ) : (
          <div className={styles.arrowContainer}>
            <span
              onClick={() => {
                setHidden(true);
              }}
              className={"icon-linear_arrow-up"}
            />
          </div>
        ))}
    </div>
  );
});
